import { lazy } from 'react'

// https://reactjs.org/docs/code-splitting.html#route-based-code-splitting
// Separated by general domains (Brand, Retailer, Passport, etc.)

// Brand
export const NewOrderReviewPage = lazy(
  () => import('features/Orders/Review/Review.page'),
)

export const PaymentSettingsPage = lazy(
  () => import('pages/PaymentSettingsPage'),
)

// The legacy /designers/view routes only redirect to the custom profile; the
// old profile pages they used to mount are no longer reachable from routing.
export const LegacyBrandProfileRedirect = lazy(
  () => import('features/Brand/BrandProfile/LegacyBrandProfileRedirect'),
)

export const DiscoveryDashboard = lazy(
  () => import('features/Brand/DiscoveryDashboard'),
)

export const ShowroomCollectionPage = lazy(
  () => import('pages/ShowroomCollectionPage'),
)

export const ShowroomCollectionListPage = lazy(
  () => import('pages/ShowroomCollectionListPage'),
)

export const ShowroomTemplateListPage = lazy(
  () => import('pages/ShowroomTemplateListPage'),
)

export const ShowroomStyleboardPage = lazy(
  () => import('pages/ShowroomStyleboardPage'),
)

export const ShowroomStyleboardListPage = lazy(
  () => import('pages/ShowroomStyleboardListPage'),
)

export const ShowroomManagementPage = lazy(
  () => import('containers/Showroom/ManageShowroom/ManageShowroom.page'),
)

export const BrandDashboardPage = lazy(() => import('pages/BrandDashboardPage'))

export const ProductCatalogPage = lazy(() => import('pages/ProductCatalogPage'))

export const PublicProductCatalogPage = lazy(
  () => import('pages/PublicProductCatalogPage'),
)

export const OrderListPage = lazy(() => import('pages/OrderListPage'))

export const CancelStylePage = lazy(
  () => import('pages/CancelReplaceStylePage/CancelReplaceStylePage'),
)

export const AnalyticsJoorPayReportPage = lazy(
  () => import('pages/AnalyticsJoorPayReportPage'),
)

export const PublicInvoicePage = lazy(
  () => import('features/Orders/PublicInvoice/PublicInvoice.page'),
)

export const StorefrontPage = lazy(
  () => import('features/Storefront/StorefrontPage'),
)

export const ThirdPartySettingsPage = lazy(
  () => import('pages/ThirdPartySettingsPage'),
)

export const ExternalPaymentsPage = lazy(
  () => import('features/Orders/ExternalPayments'),
)

export const ImportExportSettingsPage = lazy(
  () => import('features/IntegrationSettings/ExportTemplate/ExportTemplate'),
)

export const DataActivityCenterPage = lazy(
  () =>
    import('features/Retailer/Lite/DataActivityCenter/DataActivityCenter.page'),
)

export const IntegrationSettingsPage = lazy(
  () => import('features/IntegrationSettings/IntegrationSettings'),
)

export const InstagramLandingPage = lazy(
  () => import('features/Storefront/InstagramLandingPage'),
)

export const LinesheetsListViewPage = lazy(
  () => import('features/Linesheets/ListView/ListView.page'),
)

export const LinesheetsDetailViewPage = lazy(
  () => import('features/Linesheets/DetailView/DetailView.page'),
)
export const PublicPaymentsPage = lazy(
  () => import('features/Orders/ExternalPayments/Payments'),
)

export const StylesPage = lazy(() => import('features/Styles/Styles'))

export const BulkImageUploader = lazy(
  () => import('features/BulkImageUploader/BulkImageUploader'),
)

export const SwatchManagement = lazy(
  () => import('features/SwatchManagement/SwatchManagement'),
)

// Retailer
export const AttributeSettingsPage = lazy(
  () => import('pages/AttributeSettingsPage/AttributeSettingsPage'),
)

export const AssortmentReviewPage = lazy(
  () => import('pages/AssortmentReviewPage/AssortmentReviewPage'),
)

export const WorkspaceListPage = lazy(() => import('containers/WorkspaceList'))

export const DataSelfServePage = lazy(() => import('pages/DataSelfServePage'))
export const DataSelfServeTab = lazy(
  () => import('containers/DataSelfServeConfig/DataSelfServeConfigTab'),
)

export const RetailDashboard = lazy(() => import('features/RetailDashboard'))

export const FindNewBrandsPage = lazy(
  () => import('features/FindNewBrands/FindNewBrandsPage'),
)

// Reporting
export const CustomReportsPage = lazy(() => import('pages/CustomReportsPage'))

export const CustomReportPage = lazy(() => import('pages/CustomReportPage'))

export const StyleDetailPage = lazy(() => import('pages/StyleDetailPage'))

export const ProductionPage = lazy(() => import('pages/ProductionPage'))

export const DeliveryReportPage = lazy(() => import('pages/DeliveryReportPage'))

export const ShippingReportPage = lazy(
  () => import('features/ShippingReport/ShippingReport.page'),
)

export const SalesSummaryPage = lazy(() => import('pages/SalesSummaryPage'))

export const RetailSalesPage = lazy(() => import('pages/RetailSalesPage'))

export const InOrderReportPage = lazy(
  () => import('features/Orders/InOrderReport/InOrderReport.page'),
)

export const PublicRetailerProfilePage = lazy(
  () => import('features/PublicRetailerProfile/PublicRetailerProfilePage'),
)

export const RetailerProfilePage = lazy(
  () => import('features/LeadGen/RetailerProfile/RetailerProfilePage'),
)

// Permissions
export const ManagePermissionsConfigurationPage = lazy(
  () => import('pages/ManagePermissionsConfigurationPage'),
)

export const ManagePermissionsPage = lazy(
  () => import('pages/ManagePermissionsPage'),
)

export const UserPermissionsPage = lazy(
  () => import('pages/UserPermissionsPage'),
)

export const PermissionsSettingsPage = lazy(
  () => import('pages/PermissionsSettingsPage'),
)

export const ManageRegionsPage = lazy(() => import('pages/ManageRegionsPage'))

// Passport
export const PassportLandingPage = lazy(
  () => import('features/Passport/PassportLandingPage'),
)

export const PassportQuickConnect = lazy(
  () => import('modals/PassportQuickConnect'),
)

export const PassportShowroomPage = lazy(
  () => import('features/Passport/PassportShowrooms/PassportShowroomPage'),
)

export const PassportEventLandingPage = lazy(
  () => import('features/Passport/EventLanding/EventLandingPage'),
)

export const PassportFavoritesPage = lazy(
  () => import('features/Passport/Favorites/PassportFavoritesPage'),
)

// Connection
export const ConnectionPage = lazy(() => import('pages/ConnectionPage'))

export const FindNewRetailersPage = lazy(
  () => import('features/LeadGen/FindNewRetailers/FindNewRetailersPage'),
)

export const ProspectsPage = lazy(
  () => import('features/LeadGen/Prospects/ProspectsPage'),
)

// Submissions
export const SubmissionsContactPage = lazy(
  () => import('features/LeadGen/Submissions/Contact/SubmissionsContactPage'),
)
export const SubmissionsViewPage = lazy(
  () => import('features/LeadGen/Submissions/SubmissionsViewPage'),
)

export const SubmissionsListPage = lazy(
  () => import('features/LeadGen/Submissions/List/SubmissionsListPage'),
)
export const ShopifyBrandInstallPage = lazy(
  () => import('features/ShopifyIntegration/BrandSync/BrandInstallPage'),
)

export const ShopifyRetailerInstallPage = lazy(
  () =>
    import('features/ShopifyIntegration/RetailerProductSync/RetailerInstallPage'),
)

export const ShopifyBrandConfigPage = lazy(
  () => import('features/ShopifyIntegration/BrandSync/BrandConfigPage'),
)

export const ShopifyRetailerConfigPage = lazy(
  () =>
    import('features/ShopifyIntegration/RetailerProductSync/RetailerConfigPage'),
)

export const ShopifyBrandTokenPage = lazy(
  () =>
    import('features/ShopifyIntegration/BrandSync/BrandCompleteInstallationPage'),
)

export const ShopifyRetailerTokenPage = lazy(
  () =>
    import('features/ShopifyIntegration/RetailerProductSync/RetailerCompleteInstallationPage'),
)

export const ShopifyIntegrationConfigRedirect = lazy(() =>
  import('features/ShopifyIntegration/routeRedirects').then((module) => ({
    default: module.ShopifyIntegrationConfigRedirect,
  })),
)

export const ShopifyIntegrationTokenRedirect = lazy(() =>
  import('features/ShopifyIntegration/routeRedirects').then((module) => ({
    default: module.ShopifyIntegrationTokenRedirect,
  })),
)

export const ShopifyIntegrationRedirect = lazy(() =>
  import('features/ShopifyIntegration/routeRedirects').then((module) => ({
    default: module.ShopifyIntegrationRedirect,
  })),
)

//Merge Orders
export const MergeOrdersPage = lazy(
  () => import('features/Orders/MergeOrders/POSelection/POSelection.page'),
)
export const SelectProductsPage = lazy(
  () =>
    import('features/Orders/MergeOrders/SelectProducts/SelectProducts.page'),
)

export const SsoSettingsPage = lazy(() => import('pages/SsoSettingsPage'))

export const ErrorPage = lazy(() => import('pages/ErrorPage'))

export const ZendeskSSOLoginPage = lazy(
  () => import('features/Zendesk/ZendeskSSOLogin.page'),
)

export const VisualAssortmentPage = lazy(
  () => import('features/VisualAssortment/VisualAssortment.page'),
)

export const SubscriptionsPage = lazy(
  () => import('features/Subscriptions/SubscriptionsPage'),
)

// Self serve
export const UserManagementPage = lazy(
  () => import('features/UserManagement/UserManagement'),
)
